import * as ActionTypes from '../constants/actionTypes'
import api from '../utils/api'
import getFieldFromItem from '../utils/getFieldFromItem'

export const keys = []

export const editForm = formFieldsChange => ({
  type: ActionTypes.CV_SELECTED_CASEFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => async (dispatch) => {
  try {
    const paReq = await api.get('practice-areas?$limit=99&$sort[sorting_index]=1&$sort[id]=1')
    const {
      data: pa,
    } = paReq
    dispatch({
      type: ActionTypes.CV_SELECTED_CASEFORM_ENTER_RESET,
      pa,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_SELECTED_CASEFORM_FETCHITEM_FAIL,
      fetchItemError: error.message,
    })
  }
}

export const fetchItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_SELECTED_CASEFORM_FETCHITEM_LOAD })
  try {
    const item = await api.get(`cv_selected_cases/${params.id}`)
    dispatch({
      type: ActionTypes.CV_SELECTED_CASEFORM_FETCHITEM_SUCCEED,
      item,
    })
    const field = getFieldFromItem(
      item,
      //keys,
    )
    dispatch({
      type: ActionTypes.CV_SELECTED_CASEFORM_EDITFORM_CHANGE,
      field,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_SELECTED_CASEFORM_FETCHITEM_FAIL,
      fetchItemError: error.message,
    })
  }
}

export const createItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_SELECTED_CASEFORM_CREATEITEM_LOAD })
  try {
    await api.create(`cv_selected_cases`, params)
    dispatch({ type: ActionTypes.CV_SELECTED_CASELIST_CHANGETABLE_CHANGE })
    dispatch({ type: ActionTypes.CV_SELECTED_CASEFORM_CREATEITEM_SUCCEED })
    dispatch({ type: ActionTypes.CV_SELECTED_CASEFORM_ENTER_RESET })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_SELECTED_CASEFORM_CREATEITEM_FAIL,
      createItemError: error.message,
    })
  }
}

export const editItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_SELECTED_CASEFORM_EDITITEM_LOAD })
  try {
    await api.patch(`cv_selected_cases/${params.id}`, params)
    dispatch({ type: ActionTypes.CV_SELECTED_CASEFORM_EDITITEM_SUCCEED })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_SELECTED_CASEFORM_EDITITEM_FAIL,
      editItemError: error.message,
    })
  }
}

export const deleteItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_SELECTED_CASEFORM_DELETEITEM_LOAD })
  try {
    await api.delete(`cv_selected_cases/${params.id}`)
    dispatch({ type: ActionTypes.CV_SELECTED_CASEFORM_DELETEITEM_SUCCEED })
    dispatch({ type: ActionTypes.CV_SELECTED_CASEFORM_ENTER_RESET })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_SELECTED_CASEFORM_DELETEITEM_FAIL,
      deleteItemError: error.message,
    })
  }
}
